<template>
  <b-container>

  </b-container>
</template>

<script>
// @ is an alias to /src
import { SIGN_OUT } from "@/store/consts";

export default {
  name: "SignOut",
  mounted() {
      this.$store.commit(SIGN_OUT);
      this.$router.push({ name: 'sign-in' })
  }
};
</script>
